import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { Menu } from "semantic-ui-react";

/**
 * ManuscriptProperties: props => React element
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Properties panel of the manuscript editor,
 * containing view options
 *
 * @param {*} props
 */
const ManuscriptProperties = props => (
  <div>
    <h3>
      <FormattedMessage id="editor.properties.view.title" />
    </h3>
    <Menu compact>
      <Menu.Item
        name="mode.editor"
        onClick={() => props.setPreviewMode(false)}
        active={!props.isReadOnlyMode}
      >
        <FormattedMessage id="editor.properties.view.mode.editor" />
      </Menu.Item>
      <Menu.Item
        name="mode.preview"
        onClick={() => props.setPreviewMode(true)}
        active={props.isReadOnlyMode}
      >
        <FormattedMessage id="editor.properties.view.mode.preview" />
      </Menu.Item>
    </Menu>
  </div>
);

ManuscriptProperties.propTypes = {
  setPreviewMode: PropTypes.func.isRequired,
  isReadOnlyMode: PropTypes.bool.isRequired
};

export default ManuscriptProperties;



// WEBPACK FOOTER //
// ./src/modules/editor/manuscript/ManuscriptProperties.js